import React, { useMemo } from "react";
import { Button, Col, Input, Row, Table, Typography } from "antd";
import useFillHeight from "../../hooks/useFillHeight";
import { VIEW } from "../../utils/constants";

const { Search } = Input;
const { Title } = Typography;

const ListProposition = (props) => {
  const { listData, tableOption, titre } = props;
  // Table qui remplit la vue, scroll interne
  const { containerRef, height: tableHeight } = useFillHeight({
    targetSelector: ".ant-table-body",
    bottomOffset: VIEW.BOTTOM_OFFSET,
  });

  let label = "Propositions";

  // On remplace useState et useEffect par useMemo
  const lignesProp = useMemo(() => {
    // Si pas de données, on retourne un tableau vide immédiatement
    if (!listData || listData.length === 0) return [];

    // 1. Tri technique pour garantir le regroupement par requête
    const sortedData = [...listData].sort((a, b) =>
        a.requete_lot_requete.requete_id - b.requete_lot_requete.requete_id
    );

    const resultats = [];
    let listLots = [];
    let currentIdReq = null;
    let tempLigne = null;

    sortedData.forEach((ligne, index) => {
      const idReq = ligne.requete_lot_requete.requete_id;

      // Changement de groupe : on pousse la ligne précédente
      if (currentIdReq !== null && idReq !== currentIdReq) {
        tempLigne.requete_lot_reference = listLots.join(" / ");
        resultats.push(tempLigne);
        listLots = [];
      }

      // Initialisation du nouveau groupe
      if (idReq !== currentIdReq) {
        tempLigne = {
          requete_cle: ligne.key,
          requete_id: idReq,
          requete_locataire_id: ligne.requete_lot_requete.requete_locataire.locataire_id,
          requete_locataire:
              ligne.requete_lot_requete.requete_locataire.locataire_personne.personne_nom +
              " " +
              ligne.requete_lot_requete.requete_locataire.locataire_personne.personne_prenom,
          requete_date_debut: ligne.requete_lot_date_debut,
          requete_date_fin: ligne.requete_lot_date_fin,
          requete_creation: ligne.requete_lot_requete.requete_created,
        };
        currentIdReq = idReq;
      }

      listLots.push(ligne.requete_lot_lot.lot_reference);

      // Gestion du dernier élément
      if (index === sortedData.length - 1) {
        tempLigne.requete_lot_reference = listLots.join(" / ");
        resultats.push(tempLigne);
      }
    });

    // 2. TRI FINAL : De la plus récente à la plus ancienne
    return resultats.sort((a, b) => {
      return new Date(b.requete_creation) - new Date(a.requete_creation);
    });
  }, [listData]); // Le calcul n'est refait QUE si listData change

  const deleteRequete = (idReq) => {
    const requete = props.requetes.find((req) => req.requete_id === idReq);
    if (requete) {
      requete.requete_locataire_id = requete.requete_locataire?.locataire_id;
      requete.requete_dossier_id = requete.requete_dossier?.dossier_id;
      requete.requete_provenance_id = requete.requete_provenance?.provenance_id;
      requete.requete_fin = true;
      props.updateRequete(requete, idReq).then(() => {
        props.syncRequetesLots();
      });
    }
  };

  const getColumnSearchPropsDate = () => {};

  return (
    <>
      <div style={{ padding: 20 }}>
        <Row>
          <Title level={2}>
            {`${titre ? "Liste des " + label : ""} `}
            {/* Liste des {label} */}
          </Title>
        </Row>
        <Row>
          <Col span={21}>
            <Search
              placeholder="Recherche..."
              allowClear
              //onSearch={search}
              style={{ width: 300 }}
            />
          </Col>
          <Col span={3}>
            <div style={{ float: "right" }}>
              <Button className="btn-primary">
                {/* onClick={handlePrint} */}
                PDF
              </Button>
            </div>
          </Col>
        </Row>
      </div>
      <div ref={containerRef}>
        {lignesProp && (
          <Table
            className="list-data"
            dataSource={lignesProp}
            columns={tableOption(getColumnSearchPropsDate, deleteRequete)}
            pagination={false}
            rowKey={"requete_cle"}
            scroll={{ y: tableHeight ?? undefined }}
          />
        )}
      </div>
    </>
  );
};

export default ListProposition;
